import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { endpoints } from '../../utils/endpoints';
import { lastValueFrom, map } from 'rxjs';

@Injectable(    {
    providedIn: 'root',
})
export class ServerDatetimeService {
    private http = inject(HttpClient);


    getServerTime() {
        return this.http.get<string>(
            endpoints.identity.children.getServerTime()
        );
    }

    async processTimeDifference(): Promise<void> {
        const serverDate = await lastValueFrom(
            this.getServerTime().pipe(map((dateString) => new Date(dateString)))
        );
        const localDate = new Date();
        const offset = serverDate.getTime() - localDate.getTime();
        localStorage.setItem('timeOffset', JSON.stringify(offset));
    }
}
